import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { AdvertisementProvider } from "../../../context/AdvertisementContext";
import { PositionProvider } from "../../../context/PositionContext";

export const Events = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddEvent = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditEvent = () => {
  return (
    
      <AdvertisementProvider>
        
          <Edit />
        
      </AdvertisementProvider>
    
  );
};
